/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 126 24"
    data-name="SvgRectangle04"
    {...props}
  >
    {props.children}
    <path
      fill="#C9DDE9"
      d="M2 .458h121.069c.856 0 1.548.697 1.542 1.553l-.069 9.986v.006l.069 9.986a1.54 1.54 0 0 1-1.542 1.553H2c-.851 0-1.542-.69-1.542-1.542V2c0-.851.69-1.542 1.542-1.542"
    />
    <path
      fill="url(#rectangle04_svg__a)"
      fillOpacity={0.2}
      d="M2 .458h121.069c.856 0 1.548.697 1.542 1.553l-.069 9.986v.006l.069 9.986a1.54 1.54 0 0 1-1.542 1.553H2c-.851 0-1.542-.69-1.542-1.542V2c0-.851.69-1.542 1.542-1.542"
    />
    <path
      stroke="url(#rectangle04_svg__b)"
      strokeWidth={0.917}
      d="M2 .458h121.069c.856 0 1.548.697 1.542 1.553l-.069 9.986v.006l.069 9.986a1.54 1.54 0 0 1-1.542 1.553H2c-.851 0-1.542-.69-1.542-1.542V2c0-.851.69-1.542 1.542-1.542Z"
    />
    <defs>
      <linearGradient
        id="rectangle04_svg__a"
        x1={42.981}
        x2={48.047}
        y1={-2.907}
        y2={24.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="rectangle04_svg__b"
        x1={10.554}
        x2={13.78}
        y1={0.45}
        y2={28.548}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.7} />
        <stop offset={0.406} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={0.574} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.4} />
      </linearGradient>
    </defs>
  </svg>
)
